/**
 * @file automatically generated from MApp.Endpoints.WorkflowEditorController
 */ 

import { MetadataClient } from '../metadataClient';
import { IWorkflowItem, IWorkflowDocument, ITriggerProperty, IController, ISaveCustomScript, ISaveCustomStyle } from '../models';

export class WorkflowEditorClient extends MetadataClient {

    public static getWorkflows() {
        return MetadataClient.ajax<IWorkflowItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows`)
        );
    }

    public static isUniqueWorkflowName(name: string) {
        return MetadataClient.ajax<boolean>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/isunique/${encodeURIComponent(name)}`)
        );
    }

    public static getWorkflow(name: string) {
        return MetadataClient.ajax<IWorkflowDocument>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/${encodeURIComponent(name)}`)
        );
    }

    public static saveWorkflow(workflow: IWorkflowDocument) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(workflow)
			})
        );
    }

    public static updateWorkflow(name: string, workflow: IWorkflowDocument) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/${encodeURIComponent(name)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(workflow)
			})
        );
    }

    public static deleteWorkflow(name: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/${encodeURIComponent(name)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getTriggers() {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/triggers`)
        );
    }

    public static getTrigger(name: string) {
        return MetadataClient.ajax<ITriggerProperty[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/triggers/${encodeURIComponent(name)}`)
        );
    }

    public static getValueProviders() {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/valueproviders`)
        );
    }

    public static getControllers() {
        return MetadataClient.ajax<IController[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/controllers`)
        );
    }

    public static getCustomScripts(workflow: string) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customscripts/${encodeURIComponent(workflow)}`)
        );
    }

    public static getCustomScript(workflow: string, name: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customscripts/${encodeURIComponent(workflow)}/${encodeURIComponent(name)}`)
        );
    }

    public static saveCustomScript(script: ISaveCustomScript) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customscripts`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(script)
			})
        );
    }

    public static deleteCustomScript(workflow: string, name: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customscripts/${encodeURIComponent(workflow)}/${encodeURIComponent(name)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getCustomStyles(workflow: string) {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customstyles/${encodeURIComponent(workflow)}`)
        );
    }

    public static getCustomStyle(workflow: string, name: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customstyles/${encodeURIComponent(workflow)}/${encodeURIComponent(name)}`)
        );
    }

    public static saveCustomStyle(style: ISaveCustomStyle) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customstyles`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(style)
			})
        );
    }

    public static deleteCustomStyle(workflow: string, name: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customstyles/${encodeURIComponent(workflow)}/${encodeURIComponent(name)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getCustomViews() {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customviews`)
        );
    }

    public static getCustomView(name: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customviews/${encodeURIComponent(name)}`)
        );
    }

    public static saveCustomView(name: string, customView: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/customviews/${encodeURIComponent(name)}?customView=${encodeURIComponent(customView)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static getThemes() {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/workflows/themes`)
        );
    }
}
